/* src/app/shared/components/mobile-template/mobile-template.component.scss */
.phone-case {
  display: flex;
  max-height: 515px;
  max-width: 270px;
  height: 500px;
  flex-direction: column;
  -webkit-box-align: center;
  border-style: solid;
  border-width: 1px;
  border-color: #333;
  border-radius: 35px;
}
.phone-speaker {
  width: 50px;
  height: 7px;
  margin-bottom: 14px;
  margin-top: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: #333;
  border-radius: 4px;
  align-self: center;
}
.phone-screen {
  max-width: 250px;
  height: 85%;
  border-style: solid;
  border-width: 1px;
  border-color: #333;
  border-radius: 15px;
  align-self: center;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0px 5px 5px 5px;
}
/*# sourceMappingURL=mobile-template.component.css.map */
